import { utils } from '@sfaas/util';

export default {
	plants_: state => {
		const { plants } = state.selectOptions;
		return plants;
	},

	serviceKinds_: state => {
		const { serviceKinds } = state.selectOptions;
		return [{ label: 'ALL', value: 'ALL' }, ...serviceKinds];
	},

	pgmIds_: state => {
		const { pgmIds } = state.selectOptions;
		return [{ label: 'ALL', value: 'ALL' }, ...pgmIds];
	},

	procIds_: state => {
		const { procIds } = state.selectOptions;
		return [{ label: 'ALL', value: 'ALL' }, ...procIds];
	},

	plantCd_: state => {
		const { plantCd } = state.searchParams;
		return plantCd;
	},

	serviceKind_: state => {
		const { serviceKind } = state.searchParams;
		return serviceKind;
	},

	pgmId_: state => {
		const { pgmId } = state.searchParams;
		return pgmId;
	},

	procId_: state => {
		const { procId } = state.searchParams;
		return procId;
	},

	show_: state => {
		const { show } = state.popupParams;
		return show;
	},

	urlSearchParams_: state => {
		const { searchParams, pagingInfo } = state;
		const urlSearchParams = new URLSearchParams();
		Object.keys(searchParams).forEach(key => {
			const value = searchParams[key];
			if (!utils.$sf_isNull(value) && !utils.isUndefined(value) && !value.includes('ALL')) {
				urlSearchParams.set(key, value);
			}
		});
		// TODO
		Object.keys(pagingInfo).forEach(key => {
			const validKeys = ['currentPage', 'pageUnit'];
			const value = pagingInfo[key];
			if (validKeys.includes(key)) {
				urlSearchParams.set(key, value);
			}
		});
		return urlSearchParams.toString();
	},

	totalSize_: state => {
		const { pagingInfo } = state;
		const { totalSize } = pagingInfo;
		return totalSize;
	},

	pageUnit_: state => {
		const { pagingInfo } = state;
		const { pageUnit } = pagingInfo;
		return pageUnit;
	}
};
